module.exports = __webpack_public_path__ + "static/media/xz.62a7f4b4.svg";